import {
	PipeMaterial,
	TdhData,
	TdhFittings,
	TdhHelpBase,
} from "../types/types";

export type TdhFittingField = {
	id: keyof TdhFittings;
	label: string;
};

export const TDH_FITTING_FIELDS: TdhFittingField[] = [
	{ id: "thruTees", label: "Thru Tees" },
	{ id: "branchTees", label: "Branch Tees" },
	{ id: "elbows45", label: "45° Elbows" },
	{ id: "couplings", label: "Couplings" },
	{ id: "elbows90", label: "90° Elbows" },
	{ id: "gateValves", label: "Gate Valves" },
	{ id: "checkValves", label: "Check Valves" },
];

type EquivalentLengthTable = Record<keyof TdhFittings, number>;

const EQUIVALENT_LENGTHS: Record<string, EquivalentLengthTable> = {
	"1.25": {
		elbows90: 7,
		elbows45: 3,
		branchTees: 7,
		checkValves: 11,
		couplings: 1,
		gateValves: 0.9,
		thruTees: 2.3,
	},
	"1.5": {
		elbows90: 8,
		elbows45: 3,
		branchTees: 9,
		checkValves: 13,
		couplings: 1,
		gateValves: 1.1,
		thruTees: 2.7,
	},
	"2": {
		elbows90: 9,
		elbows45: 4,
		branchTees: 11,
		checkValves: 17,
		couplings: 2,
		gateValves: 1.4,
		thruTees: 3.5,
	},
	"2.5": {
		elbows90: 10,
		elbows45: 4,
		branchTees: 14,
		checkValves: 21,
		couplings: 3,
		gateValves: 1.7,
		thruTees: 4.1,
	},
	"3": {
		elbows90: 12,
		elbows45: 6,
		branchTees: 17,
		checkValves: 26,
		couplings: 4,
		gateValves: 2,
		thruTees: 5.1,
	},
	"4": {
		elbows90: 14,
		elbows45: 8,
		branchTees: 22,
		checkValves: 33,
		couplings: 5,
		gateValves: 2.3,
		thruTees: 6.7,
	},
};

export function getFittingEquivalentLength(
	pipeDiameter: string,
	fitting: keyof TdhFittings,
): number {
	return EQUIVALENT_LENGTHS[pipeDiameter]?.[fitting] ?? 0;
}

export function createDefaultFittings(): TdhFittings {
	return {
		thruTees: "0",
		branchTees: "0",
		elbows45: "0",
		couplings: "0",
		elbows90: "0",
		gateValves: "0",
		checkValves: "0",
	};
}

function createDefaultTdhHelpBase(): TdhHelpBase {
	return {
		staticHead: "",
		pipeDiameter: "",
		pipeMaterial: "",
		horizontalLength: "",
		fittings: createDefaultFittings(),
		totalLengthOfPipe: "",
	};
}

export function createDefaultTdhData(): TdhData {
	return {
		mode: "known",
		knownTdh: "",
		calculatedTdh: "",
		sump: {
			...createDefaultTdhHelpBase(),
			dischargeIntoForceMain: false,
			psi: "",
		},
		standard: createDefaultTdhHelpBase(),
	};
}

/** Friction coefficient (C) by pipe material, used in the TDH friction head formula. */
export const PIPE_FRICTION_COEFFICIENT: Record<
	Exclude<PipeMaterial, "">,
	number
> = {
	plastic: 150,
	iron: 120,
};

export function getPipeFrictionCoefficient(pipeMaterial: PipeMaterial): number {
	if (!pipeMaterial) {
		return PIPE_FRICTION_COEFFICIENT.plastic;
	}

	return PIPE_FRICTION_COEFFICIENT[pipeMaterial];
}
